<template>
    <div>
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <textarea-form-group
                v-model="data.text"
                name="text"
                label="Text"
                :error="(errors.text || [])[0]"
        />
    </div>
</template>

<script>
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
    import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'

    export default {
        components: {TextFormGroup, TextareaFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
